import { theme } from '@factorialco/deprecated-design-system'
import { ThemeAPI } from '@getnuvo/importer-react'

export const progressBar: ThemeAPI['progressBar'] = {
  root: {
    backgroundColor: theme.colors.grey000White,
    borderRadius: theme.borderRadius.medium,
    border: `${theme.border.width.s1} ${theme.border.style.solid} ${theme.border.color.grey000White}`,
    padding: theme.dimensions.s0,
  },
  icon: {
    color: theme.colors.viridian1000,
  },
  current: {
    color: theme.colors.grey1000,
    fontSize: theme.fontSizes[100],
  },
  complete: {
    color: theme.colors.grey800,
  },
  incomplete: {
    color: theme.colors.grey600,
  },
}
